import { render, staticRenderFns } from "./AdminPreviewBanner.vue?vue&type=template&id=5a63aa0a&scoped=true"
import script from "./AdminPreviewBanner.vue?vue&type=script&lang=js"
export * from "./AdminPreviewBanner.vue?vue&type=script&lang=js"
import style0 from "./AdminPreviewBanner.vue?vue&type=style&index=0&id=5a63aa0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a63aa0a",
  null
  
)

export default component.exports